/**
 * Wraps action cell content and reports its intrinsic width so the column can use max(all row widths).
 */

import { useLayoutEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';

interface MeasuredActionsCellProps {
  children: React.ReactNode;
  onMeasure: (_width: number) => void;
}

export const MeasuredActionsCell = ({
  children,
  onMeasure,
}: MeasuredActionsCellProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const report = () => {
      const w = el.getBoundingClientRect().width;
      if (w > 0) onMeasure(w);
    };
    report();
    const ro = new ResizeObserver(report);
    ro.observe(el);
    return () => ro.disconnect();
  }, [onMeasure]);

  return (
    <Box ref={ref} display="inline-block" bg="inherit">
      {children}
    </Box>
  );
};
